import { Col } from "antd";
import EditCompanyProfile from "containers/Company/CompanyProfile/EditCompanyProfile/EditCompanyProfile";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import { Route, Switch } from "react-router-dom";
import { Company } from "interfaces/companies";
import CompanyBreadcrumb from "components/CompanyBreadCrumb/CompanyBreadCrumb";
import CreateOrEditJobPosting from "../CreateJobPosting/CreateOrEditJobPosting";
import ContactPersons from "./ContactPersons/ContactPersons";
import Events from "./Events/Events";
import Jobs from "./Jobs/Jobs";
import Overview from "./Overview/Overview";
import CompanyAccountSettings from "./CompanyAccountSettings";

const CompanyProfilePage = () => {
  const { currentUser } = useLoginContext();

  if (!isCompanyUser(currentUser)) return null;
  return (
    <>
      <Col
        span={24}
        style={{
          padding: "24px 48px",
        }}
      >
        <CompanyBreadcrumb />
        <Switch>
          <Route path="/company/company-profile/events/" component={Events} />
          <Route path="/company/company-profile/jobs/create-job-posting" component={CreateOrEditJobPosting} />
          <Route path="/company/company-profile/jobs/:id/edit/">
            <CreateOrEditJobPosting existingJob />
          </Route>
          <Route path="/company/company-profile/jobs/" component={Jobs} />
          <Route path="/company/company-profile/contact-persons/" component={ContactPersons} />
          <Route
            path="/company/company-profile/edit-profile/"
            render={() => <EditCompanyProfile company={(currentUser as unknown) as Company} />}
          />
          <Route path="/company/company-profile/account/">
            <CompanyAccountSettings />
          </Route>
          <Route path="/company/company-profile/" component={Overview} />
        </Switch>
      </Col>
    </>
  );
};

export default CompanyProfilePage;
